import styled from 'styled-components'

export const Composition = styled.div`
  text-align: center;
`
